// API Configuration
// In production (deployed), use relative URLs (empty REACT_APP_BACKEND_URL)
// In development (preview), use the full preview URL

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
const AUTH_URL = process.env.REACT_APP_AUTH_URL || '';
const GOOGLE_OAUTH_URL = process.env.REACT_APP_GOOGLE_OAUTH_URL || '';

export { BACKEND_URL, API, AUTH_URL, GOOGLE_OAUTH_URL };
